import {types} from '../../types';

const setLoadingAction = (payload) => {
  return {
    type: types.common.SET_LOADING,
    payload,
  }
}

export {
  setLoadingAction
}